import React, {useEffect, useState} from 'react';

// mui utils
import useMediaQuery from '@mui/material/useMediaQuery';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';

// iAngels utils
import WingsLogo from '../../assets/iAngels_green_wings_logo.png';
import { MOBILE_WIDTH_460 } from '../../helpers/constants';
import { getUserSelector } from '../App/selectors';
import Enveloppe from '../../assets/enveloppe.svg';
import Text from '../../components/text';
import Divider from '@mui/material/Divider';
import ShareByEmail from '../../components/ShareByEmail';
import { getShareSelector } from './selectors';
import { clearShareContext } from './actions';
import {rolloverInvestmentsAttempt,clearRolloverToInvest,rolloverPopupAttempt,setPopup} from '../RolloverPopup/actions';
import {clearInvestmentState} from '../Invest/actions';
import {getInvestmentAttemptingSelector} from '../Invest/selectors'
import {getRolloversToInvestSelector, getSaveRolloverIndexSelector, getRolloverAttemptingInvestSelector,getRolloverInvestmentSuccessSelector,
  getRolloverEntitiesSelector,getSelectedKYCSelector
} from '../RolloverPopup/selectors';
import LoadingIndicator from '../../components/Generic/LoadingIndicator';

// third party utils
import { useSelector,useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

const ThankYouPage = () => {
  // hooks
  const matches = useMediaQuery(MOBILE_WIDTH_460);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(getUserSelector);
  const rolloversToInvest =  useSelector(getRolloversToInvestSelector);
  const rolloverAttemptingInvest =  useSelector(getRolloverAttemptingInvestSelector);
  const rolloverEntities = useSelector(getRolloverEntitiesSelector);
  const selectedKYC = useSelector(getSelectedKYCSelector);
  const loadingInvestment = useSelector(getInvestmentAttemptingSelector);
  const saveRolloverIndex= useSelector(getSaveRolloverIndexSelector);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const rolloverInvestmentsSuccess = useSelector(getRolloverInvestmentSuccessSelector);
  const share = useSelector(getShareSelector);

  // clear share context on unmount so users can share again later
  useEffect(() => {
    return () => {
      try { dispatch(clearShareContext()); } catch (e) { /* ignore */ }
    };
  }, [dispatch]);

  
  useEffect(() => {
    if (rolloversToInvest && !rolloverAttemptingInvest &&!loadingInvestment && params?.investmentId===rolloverInvestmentsSuccess.id)
     { 
        if(saveRolloverIndex < rolloversToInvest.length) {
          setLoading(true);
          dispatch(clearInvestmentState());
          dispatch(rolloverInvestmentsAttempt(rolloversToInvest[saveRolloverIndex]));
        }
        else
        {
            // clear saveRolloverIndex and rolloversToInvest
            // check if allrollover done need to asign user to false on popup in order to prevent loading again this is done on the dispatch(rolloverPopupAttempt()) and also send relevant cash balance to sync;
            // navigate to thank you page and then to dashboard or load before the popuppage again in case there is more kyc
            let closePopup=true;
            dispatch(clearRolloverToInvest());
            if(rolloverEntities?.length>1 && selectedKYC!=="All" )
              closePopup=false;
            dispatch(rolloverPopupAttempt());
            dispatch(clearInvestmentState());
            setLoading(false);
            if(closePopup)
              dispatch(setPopup(false));


        }
      }
  }, [rolloversToInvest, saveRolloverIndex,rolloverAttemptingInvest,loadingInvestment,params,rolloverInvestmentsSuccess,rolloverEntities,selectedKYC,dispatch]); 



  if (!user) {
    return null;
  }

  return (
    <>
    {loading ? 
      <LoadingIndicator/>
     : (
    <Container
      style={{
        padding: 0,
        marginTop: 40,
        minHeight: 800,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Paper
        elevation={3}
        style={{
          maxWidth: 700,
          borderRadius: 0,
          padding: '30px 50px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center',  marginBottom: 10 }}>
          <img src={WingsLogo} className="pointer" alt="logo"  />
          <Text classes="f-f-tgf f-f-500 f-size-20 mt-20 g3-c" style={{ fontSize: 24 ,textAlign: 'center'}} text="Thank you for investing" />
          <Text
            classes="f-f-g f-w-400 f-size-14 mt-15 mb-15 g4-c"
            style={{  maxWidth: 500, textAlign: 'center', lineHeight: 1.5 }}
            variant="body2 f-size-16"
            text="We look forward to being at your service as you build your start-up investment portfolio at iAngels."
          />
        </div>

        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Divider style={{ width: '100%' }} />

          <div style={{ display: 'flex', marginTop: 25 }}>
            <img src={Enveloppe} alt="Enveloppe" style={{ marginRight: 20 }} />
            <Text
              classes="f-f-g f-w-400 f-size-14 g4-c"
              style={{ marginTop: 10 }}
              variant="body2"
              text="An email with the wire instructions for your investment will be sent to this address: "
              extraText={user.email}
              extraClasses="g3-c"
            />
          </div>

          {/* Share by email section */}
          {share?.companyName && !rolloversToInvest ? (
            <>
              <Divider style={{ width: '100%', marginTop: 20, marginBottom: 8 }} />
              <div style={{ width: '100%' }}>
                <ShareByEmail companyName={share.companyName} companyUrl={share.companyUrl} investorName={share.investorName} />
              </div>
            </>
          ) : null}
        </div>
        <div className="mt-20" style={{ display: 'flex', flexDirection:  matches ?  'column': 'row', width: '100%', gap: 10 }}>
          <Button
            variant="contained"
            className="btn f-size-12 f-w-500"
            style={{ marginTop: 15, flex: 1, minWidth: 0, minHeight: 40, borderRadius: 6 }}
            onClick={() => navigate('/dashboard')}
          >
            My Portfolio
          </Button>
          <Button
            variant="contained"
            className="btn f-size-12 f-w-500"
            style={{ marginTop: 15, flex: 1, minWidth: 0, minHeight: 40, borderRadius: 6 }}
            onClick={() => navigate('/investment-opportunities')}
          >
            More Opportunities
          </Button>
        </div>
        <Text
        text="If you would like to share your with us about your experience so far, please leave your"
        extraText=" feedback here."
        classes="g4-c mt-20 f-size-12 italic f-f-pmp"
        handleClick={() => window.openHubSpotChat()}
        extraClasses="g3-c pointer"
      />
      </Paper>
      
     
    </Container>)}
    </>
  );
};

export default ThankYouPage;
